(() => {
  // Keep the app's tested focus trap, Escape and dismissal handlers intact.
  // Give each mounted signup dialog the accessible name of its visible heading.
  let headingSequence = 0;
  let scheduled = false;

  const labelDialogs = () => {
    scheduled = false;
    document.querySelectorAll('[role="dialog"]').forEach((dialog) => {
      const form = dialog.querySelector('form.klaviyo-form');
      if (!form) return;
      const heading = form.querySelector('h1, h2, h3, [role="heading"]');
      if (!heading || !heading.textContent.trim()) return;
      if (!heading.id) heading.id = `fff-signup-heading-${++headingSequence}`;
      if (dialog.getAttribute('aria-labelledby') !== heading.id) {
        dialog.setAttribute('aria-labelledby', heading.id);
      }
      dialog.setAttribute('data-fff-signup-dialog', '');
      // The inherited form scales a 1000px two-column layout on phones. Mark
      // only its empty decorative-image column so the mobile form can reflow.
      [...form.children].forEach((column) => {
        if (
          column.querySelector('img[alt=""]') &&
          !column.querySelector('input, button, a, select, textarea') &&
          !column.textContent.trim()
        ) {
          column.setAttribute('data-fff-signup-image', '');
        }
      });
    });
  };

  const scheduleLabels = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(labelDialogs);
  };

  new MutationObserver(scheduleLabels).observe(document.body, {
    childList: true,
    subtree: true,
  });
  labelDialogs();
})();
